document.addEventListener("DOMContentLoaded", () => {
  const $Nav = $(".secondary-nav-item");
  const $OpenBtn = $(".open-menu-btn");
  const $CloseBtn = $(".close-menu-btn, .mb-close-menu-btn");
  const $DrawMenu = $(".drawer-menu-panel");
  const $FristNav = $(".first-nav-item");
  const $SecondaryNav = $(".mb-secondary-row");
  const $ReturnBtn = $(".return-btn");
  const $SecondaryPanel = $(".mb-nav-secondary-panel");
  const $Body = $("body");
  const $MbPanel = $(".mb-nav-panel");

  $Nav.hover(function () {
    var $this = $(this);

    if (!$this.hasClass("active")) {
      var $Parent = $this.parents(".nav-panel-box");
      var index = $this.attr("index");
      const $NavContent = $Parent.find(".secondary-nav-item-content");
      $Parent.find(".secondary-nav-item").removeClass("active");
      $this.addClass("active");
      $NavContent.removeClass("active");
      $Parent
        .find(`.secondary-nav-item-content[index='${index}']`)
        .addClass("active");
    }
  });

  $FristNav.click(function () {
    var $this = $(this);
    var index = $this.attr("index");
    $(`.mb-nav-secondary-panel[index='${index}']`).show();
  });

  $SecondaryNav.click(function () {
    var $this = $(this);
    $this.siblings(".mb-secondary-item-box").slideToggle();
    $this.find(".nav-item-arrow").toggleClass("active");
  });

  $OpenBtn.click(function () {
    $(this).hide();
    $CloseBtn.show();
    $DrawMenu.show();
    $Body.addClass("not-scroll");
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 1) {
      $MbPanel.addClass("rolled");
    }
  });

  $CloseBtn.click(function () {
    $CloseBtn.hide();
    $OpenBtn.show();
    $DrawMenu.hide();
    $SecondaryPanel.hide();
    $Body.removeClass("not-scroll");
    $MbPanel.removeClass("rolled");
  });

  $ReturnBtn.click(function () {
    $SecondaryPanel.hide();
  });

});
